<template>
  <a-modal
      :title="title"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
    <div>
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="名称"
          :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
          <a-input
            v-decorator="['name', { rules: [] }]"
            :placeholder="markerSetDefaultValue"
          />
        </a-form-item>
        <a-form-item label="备注"
          :label-col="{ span: 3 }" :wrapper-col="{ span: 19 }">
          <a-textarea
            v-decorator="['remarks', { rules: [] }]"
            placeholder=""
            auto-size
          />
        </a-form-item>
        <a-form-item
          help="标记之间用线连接起来"
          label="连线" :label-col="{ span: 3 }">
          <a-switch
            v-decorator="['showPolyline', { initialValue: false, valuePropName: 'checked' }]"
          />
        </a-form-item>
        <a-form-item
          help="分享后允许朋友共同编辑"
          label="协作" :label-col="{ span: 3 }">
          <a-switch
            v-decorator="['shareWithEditable', { initialValue: false, valuePropName: 'checked' }]"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    markerSet: Object,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      title: '编辑标记集',
      markerSetDefaultValue: `标记集-${new Date().getTime()}`,
    };
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    async addMarkerSet() {
      const data = this.form.getFieldsValue();
      data.name = data.name ? data.name : this.markerSetDefaultValue;
      await this.$api.proxy.markerSetAdd({
        markerSet: data,
      });
    },
    async updateMarkerSet() {
      const data = this.form.getFieldsValue();
      data.name = data.name ? data.name : this.markerSetDefaultValue;
      data._id = this.markerSet._id;
      await this.$api.proxy.markerSetUpdate({
        markerSet: data,
      });
    },
    async handleOk() {
      // this.handleCancel();
      console.log(this.form.getFieldsValue());
      if (!this.markerSet) {
        // 添加标记集
        await this.addMarkerSet();
      } else {
        // 更新标记集
        await this.updateMarkerSet();
      }
      this.handleCancel();
      this.$emit('update');
    },
    handleCancel() {
      this.$emit('update:visible', false);
    },
  },
  watch: {
    async visible(newVal) {
      if (newVal) {
        this.form.resetFields();
        if (this.markerSet) {
          await this.$nextTick();
          // 回显数据
          this.form.setFieldsValue({
            name: this.markerSet.name,
            remarks: this.markerSet.remarks,
            showPolyline: this.markerSet.showPolyline,
            shareWithEditable: this.markerSet.shareWithEditable,
          });
        }
      }
    },
  },
};
</script>
